import { render } from "./LinkPreview.vue?vue&type=template&id=db8dbb02"
import script from "./LinkPreview.vue?vue&type=script&lang=js"
export * from "./LinkPreview.vue?vue&type=script&lang=js"

import "./LinkPreview.vue?vue&type=style&index=0&id=db8dbb02&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__